import { PaymentMethod } from '@shared/interfaces/payment-method';
import { Observable } from 'rxjs';

export const PAYMENT_METHODS_REPOSITORY = 'PaymentMethodsRepository';

export interface PaymentMethodsRepository {
  url: string;

  getItems(): Observable<any>;

  add(paymentMethod: PaymentMethod): Observable<any>;

  edit(paymentMethod: PaymentMethod): Observable<any>;

  delete(item: any): Observable<any>;
}
